webpackJsonp([18],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(498),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73b923a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS42NCA1OC4yIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS13aWR0aDoxMXB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjUuNSIgeTE9IjI4Ljk4IiB4Mj0iNzcuODMiIHkyPSIyOC45OCIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjYyLjY1IiB5MT0iNTAuNDIiIHgyPSI4My44NyIgeTI9IjI5LjIiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI2Mi4xOSIgeTE9IjcuNzgiIHgyPSI4My40MSIgeTI9IjI5Ii8+PC9nPjwvZz48L3N2Zz4=");

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(496);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("0fb0014e", content, true, {});

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.backBtn[data-v-73b923a0] {\n  width: 40px;\n  margin: auto;\n}\n.mainDiv[data-v-73b923a0] {\n  text-align: center;\n  padding: 6px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Registration/Takanon.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,aAAa;CACd","file":"Takanon.vue","sourcesContent":["\n.backBtn[data-v-73b923a0] {\n  width: 40px;\n  margin: auto;\n}\n.mainDiv[data-v-73b923a0] {\n  text-align: center;\n  padding: 6px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "takanon",
  methods: {
    goBack: function goBack() {
      this.$router.push("/registration");
    }
  }
});

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainDiv"
  }, [_c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": __webpack_require__(224).default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.takanon.title")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100%",
      "font-size": "14px",
      "text-align": "var(--src-position)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('registration.takanon.text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": __webpack_require__(224).default
    }
  })], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 18.ce03fd3d81a126f24b18.bundle.js